module.exports = {
          srcSet: __webpack_public_path__ + "2ab21731384d5097de2cd5ec93a676d2-1125.png"+" 1125w",
          images:[ {path: __webpack_public_path__ + "2ab21731384d5097de2cd5ec93a676d2-1125.png",width: 1125,height: 292}],
          src: __webpack_public_path__ + "2ab21731384d5097de2cd5ec93a676d2-1125.png",
          toString:function(){return __webpack_public_path__ + "2ab21731384d5097de2cd5ec93a676d2-1125.png"},
          
          width: 1125,
          height: 292
        }